import type { APICallerFactory } from '@phi/frontend/api';
import { stripe_api_provider } from './api';
import { open_stripe_store_factory } from './use-cases/open-stripe-store';

export type IStripeService = ReturnType<typeof stripe_service_provider>;

export const stripe_service_provider = (api: APICallerFactory) => {
    const stripe_api = stripe_api_provider(api);
    const open_store = open_stripe_store_factory(stripe_api);
    return { open_store, api: stripe_api };
};
